<template>
  <AppModal @close="setCloseModal"
            :show="openFromOtherComponent">>
    <h1 slot="header">{{ $t('vue2.editCalendarDelete.delete_calendar') }}</h1>
    <div slot="body">
      <div class="content">
        <div class="marg-10-bottom">
          <p>{{ $t('vue2.editCalendarDelete.deleting_this_calendar') }}:</p>
          <h2>{{ calName }}</h2>
        </div>
        <div class="marg-10-bottom">
          <h3 class="warning-text bold">
            {{ $t('vue2.editCalendarDelete.all_data_will_be_deleted') }}
          </h3>
        </div>
        <p class="bold">{{ $t('vue2.editCalendarDelete.write') }} "{{ $t('vue2.editCalendarDelete.validator_name') }}" -
          {{ $t('vue2.editCalendarDelete.if_you_want_to_delete') }}:</p>
        <input type="text"
               v-model="validatorText"
               @keyup="validateInput"/>
      </div>
    </div>
    <div slot="footer"
         class="flex flex-end align-center pad-10">
      <p v-if="!validateInput()" class="warning-text marg-10-right">
        {{ $t('vue2.editCalendarDelete.you_have_to_write') }} "{{ $t('vue2.editCalendarDelete.validator_name') }}"
      </p>
      <button v-if="validateInput()"
              @click="submitDelete"
              class="submit-btn bttn--warning">
        {{ $t('vue2.editCalendarDelete.delete_calendar') }}
      </button>
      <button v-else class="submit-btn--disabled">
        {{ $t('vue2.editCalendarDelete.delete_calendar') }}
      </button>
    </div>
  </AppModal>
</template>

<script>
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import AppModal from '../CreateCalendars/Modal'

export default {
  components: {AppModal},
  props: {
    calendar: {
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      validatorText: '',
      validatorTextOriginal: this.$t('vue2.editCalendarDelete.validator_name')
    }
  },
  computed: {
    calName () {
      return this.calendar ? this.calendar.name : ''
    },
    openFromOtherComponent () {
      return eventbus.editCalendarDeleteModal
    }
  },
  methods: {
    validateInput () {
      return this.validatorText === this.validatorTextOriginal
    },
    setCloseModal () {
      this.validatorText = ''
      eventbus.editCalendarDeleteModal = false
    },
    submitDelete () {
      docendo.schoolCalendarsDelete(
        this.calendar.school_id,
        this.calendar.id,
        success => {
          eventbus.toast = {text: this.$t('vue2.editCalendarDelete.success_text'), 'success': true}
        },
        errors => {
          eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
        })
      this.setCloseModal()
      window.location.href = '/calendar'
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.flex-end {
  justify-content: flex-end;
}

.missing-input {
  border-color: var(--danger);
}

.warning-text {
  color: var(--danger);
}

.submit-btn--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f6f7f8 !important;
  border: 1px solid #d8d8d8 !important;
}

.content {
  border: 1px solid #cccccc;
  padding: 20px;
  background: white;
}
</style>



// WEBPACK FOOTER //
// EditCalendarDelete.vue?05abf7b0